import React from "react";
import { Container, Header, Grid, Box, StatusIndicator, SpaceBetween } from "@cloudscape-design/components";
import { CustomerData } from "../../services";
import { StatusMapper } from "../../utils";
import { StatusInfo } from "../../utils/StatusMapper";
import { LABELS } from "../../constants";

interface StatusBoxProps {
  data: CustomerData;
}

interface StatusCardProps {
  title: string;
  status: StatusInfo;
}

const StatusCard: React.FC<StatusCardProps> = ({ title, status }) => (
  <Box padding="m">
    <SpaceBetween size="xs">
      <Box variant="awsui-key-label" fontSize="body-s">
        {title}
      </Box>
      <StatusIndicator type={status.type}>{status.label}</StatusIndicator>
      {status.description && (
        <Box variant="small" color="text-status-inactive">
          {status.description}
        </Box>
      )}
    </SpaceBetween>
  </Box>
);

export const StatusBox: React.FC<StatusBoxProps> = ({ data }) => {
  const abRegistration = data["ab-registration"];
  const abGuest = data["ab-guest"];
  const rfd = data.rfd;

  return (
    <Container header={<Header variant="h2">{LABELS.ACCOUNT_STATUS}</Header>}>
      <Grid gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]}>
        <StatusCard title={LABELS.REGISTRATION} status={StatusMapper.getRegistrationStatus(abRegistration)} />
        <StatusCard title={LABELS.INTERNAL} status={StatusMapper.getInternalStatus(abRegistration)} />
        <StatusCard title={LABELS.SHUMA} status={StatusMapper.getShumaStatus(rfd)} />
        <StatusCard title={LABELS.GUEST} status={StatusMapper.getGuestStatus(abGuest)} />
      </Grid>
    </Container>
  );
};
